export const HERO_COLUMN_GAP = '24px';
export const HERO_BULLETS_PADDING_TOP = 'SP10';
export const HERO_TITLE_HEIGHT = 'var(--wds-font-line-height-heading-1)';
//# sourceMappingURL=heroGeometry.js.map